export default "__VITE_ASSET__BFr_xcew__"